module.exports = __webpack_public_path__ + "img/epic-name.543fb759.png";